import { ApolloQueryResult } from 'apollo-client';
import { get } from 'lodash';
import { ofType } from 'redux-observable';
import { EMPTY, from, of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

import { UPDATE_GRID_BANNER_PRICE_CELL, UpdateGridBannerPriceCell } from '../actions/banners-grid';
import { deleteEditCellData, requestGridItemsBySelection, updateEditCellData } from '../actions/grid-screen';
import { selectGridSourceParams } from '../selectors/gridSourceParams/gridSourceParams';
import { mapBannerPriceErrors } from '../service/BannerEditErrors/BannerEditErrors';
import { getBannerPriceDataToApi } from '../service/BannerHelpers/BannerHelpers';
import { ApiMethodExecutingError } from '../service/Errors';
import { DnaEpic, DnaEpicAction } from '../typings/epic';
import { updateAdPrices } from '../typings/graphql-grid';

export const updateGridBannerPriceCellEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(UPDATE_GRID_BANNER_PRICE_CELL),
        mergeMap(
            (action: UpdateGridBannerPriceCell): DnaEpicAction => {
                const state = store$.value;
                const sourceParams = selectGridSourceParams(state);
                const { bannerPrice } = action.params;

                if (!sourceParams || !bannerPrice) {
                    return EMPTY;
                }

                const cellKey = {
                    ...action.cellKeyPartial,
                    view: sourceParams.view
                };

                const requestData = {
                    id: action.params.bannerId,
                    price: getBannerPriceDataToApi(action.params.bannerPrice)
                };

                return from(deps.bannersMutationExecutor.updateAdPrice([requestData])).pipe(
                    mergeMap(
                        (result: ApolloQueryResult<updateAdPrices>): DnaEpicAction => {
                            const errors = get(result, 'data.updateAdPrices.validationResult.errors', []);

                            if (errors.length) {
                                return of(
                                    updateEditCellData(cellKey, {
                                        isSaving: false,
                                        error: mapBannerPriceErrors([
                                            {
                                                path: '',
                                                params: null,
                                                code: 'API_ERROR'
                                            }
                                        ])
                                    })
                                );
                            }

                            return [
                                deleteEditCellData(cellKey),
                                requestGridItemsBySelection(sourceParams.view, { banners: [action.params.bannerId] })
                            ];
                        }
                    ),
                    catchError((error: ApiMethodExecutingError) => {
                        return of(
                            updateEditCellData(cellKey, {
                                isSaving: false,
                                error: get(error, 'errors', '').length
                                    ? mapBannerPriceErrors(error.getErrors())
                                    : mapBannerPriceErrors([
                                          {
                                              path: '',
                                              params: null,
                                              code: 'API_ERROR'
                                          }
                                      ])
                            })
                        );
                    })
                );
            }
        )
    );
};
